import "../globals.css";
import "@rainbow-me/rainbowkit/styles.css";
import "tailwindcss/tailwind.css";

import type { AppProps } from "next/app";
import { Bebas_Neue } from "next/font/google";
import Head from "next/head";
import Script from "next/script";
import { SessionProvider } from "next-auth/react";
import { createContext, useEffect, useState } from "react";

import { cn } from "@/utils";

import { EthereumProviders } from "../components/EthereumProviders";

const bebasNeue = Bebas_Neue({
  weight: "400",
  subsets: ["latin"],
  variable: "--font-sans",
});

export const ThemeContext = createContext({
  themeColor: "#23C552",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setThemeColor: (_color: string) => {},
});

const MyApp = ({
  Component,
  pageProps,
  trackId,
}: AppProps & { trackId: string }) => {
  const [themeColor, setThemeColor] = useState("#23C552");

  useEffect(() => {
    const body = document.querySelector("body");
    if (body) {
      body.style.backgroundColor = themeColor;
    }
  }, [themeColor]);
  return (
    <>
      <Head>
        <title>Speedtracer</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, viewport-fit=cover"
        />
        <meta id="theme-color" name="theme-color" content={themeColor} />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#23c552" />
        <meta name="msapplication-TileColor" content="#00a300" />
        <meta property="fc:frame" content="vNext" />

        <meta
          property="fc:frame:post_url"
          content="https://speedtracer.xyz/api/frame"
        />
        <meta property="fc:frame:button:1" content="Random Track 🔄" />
        <meta property="fc:frame:button:1:action" content="post" />
        <meta property="fc:frame:button:2" content="Leaderboard 🏆" />
        <meta property="fc:frame:button:2:action" content="post" />
        <meta property="fc:frame:button:3" content="My Time To Beat ⏱️" />
        <meta property="fc:frame:button:3:action" content="post" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content="Speedtracer" />
        <meta property="twitter:description" content="" />
        <meta
          property="description"
          content="Speedtracer is a free daily casual mobile game. Trace a racetrack as quick as you can without crashing! 🏎️💨"
        />
      </Head>
      <Script src="https://cdn.jsdelivr.net/npm/path-data-polyfill@1.0.4/path-data-polyfill.min.js"></Script>
      <main className={cn("font-Bebas antialiased", bebasNeue.variable)}>
        <EthereumProviders>
          <ThemeContext.Provider value={{ themeColor, setThemeColor }}>
            <SessionProvider session={pageProps.session}>
              <Component {...pageProps} />
            </SessionProvider>
          </ThemeContext.Provider>
        </EthereumProviders>
      </main>
    </>
  );
};

export default MyApp;
